import { setProperty, getProperty } from "dot-prop";

const errorsArrayProp = "myErrors";
const errorCodeProp = "errorCode";
const errorMessageProp = "errorMessage";

export function setError(responseData, code, message) {
  let myErrors = getProperty(responseData, errorsArrayProp);

  if (!myErrors) setProperty(responseData, errorsArrayProp, (myErrors = []));

  let errorObj = {};
  setProperty(errorObj, errorCodeProp, code);
  setProperty(errorObj, errorMessageProp, message);

  myErrors.push(errorObj);
}

export function getErrors(responseData) {
  return responseData?.[errorsArrayProp];
}

export function hasError(response) {
  return Boolean(
    getErrors(response.data) ||
      !(response.status >= 200 && response.status < 300)
  );
}

export function isValidErrorsArray(errorsArray) {
  return errorsArray && errorsArray instanceof Array && errorsArray.length > 0;
}
